<ion-app>
  <div class="global-header-overlay" *ngIf="apiService.access_token">
    <app-switch-account></app-switch-account>
  </div>

  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">

      <ion-header>
        <ion-toolbar>
          <ion-title>Tips Pulse</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>

        <ion-list id="inbox-list" style="margin-top:10px;" *ngIf="apiService.show_sidebar_menu">

          <ion-menu-toggle auto-hide="false" *ngIf="role?.streaming_dashboard">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/streaming-dashboard']" lines="none"
              detail="false" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" name="stats-chart-outline"></ion-icon>
              <ion-label>Financial Streaming Dashboard</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" *ngIf="role?.revenue_dashboard">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/revenue-dashboard']" lines="none"
              detail="false" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" name="stats-chart-outline"></ion-icon>
              <ion-label>Financial Revenue Dashboard</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" *ngIf="role?.warner_dashboard">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/warner-dashboard']" lines="none"
              detail="false" routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" name="stats-chart-outline"></ion-icon>
              <ion-label>Warner Dashboard</ion-label>
            </ion-item>
          </ion-menu-toggle>


          <ng-container *ngFor="let item of appPages">
            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" lines="none" [routerLink]="['/'+item.url]" lines="none" detail="false"
                routerLinkActive="selected">
                <ion-icon aria-hidden="true" slot="start" [name]="item.icon"></ion-icon>
                <ion-label>{{ item.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>

          </ng-container>

          <ng-container *ngIf="canAccessBulkMenu">
            <ion-item lines="none" button detail="false" (click)="toggleBulkMenu()">
              <ion-icon aria-hidden="true" slot="start" name="folder-open-outline"></ion-icon>
              <ion-label>Bulk</ion-label>
              <ion-icon aria-hidden="true" slot="end"
                [name]="bulkMenuOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
            </ion-item>
            <ion-list style="margin-left: 15px;" *ngIf="bulkMenuOpen">
              <ion-menu-toggle auto-hide="false">
                <ion-item
                  *ngIf="canAccessBulkInsertMenu"
                  routerDirection="root"
                  lines="none"
                  [routerLink]="['/bulk-upload']"
                  detail="false"
                  routerLinkActive="selected"
                >
                  <ion-icon aria-hidden="true" slot="start" name="cloud-upload-outline"></ion-icon>
                  <ion-label>Bulk Insert</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false">
                <ion-item
                  *ngIf="canAccessBulkHistoryMenu"
                  routerDirection="root"
                  lines="none"
                  [routerLink]="['/bulk-upload-history']"
                  detail="false"
                  routerLinkActive="selected"
                >
                  <ion-icon aria-hidden="true" slot="start" name="time-outline"></ion-icon>
                  <ion-label>Bulk History</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false" *ngIf="canAccessBulkUpdateMenu">
                <ion-item routerDirection="root" lines="none" [routerLink]="['/bulk-update']" detail="false"
                  routerLinkActive="selected">
                  <ion-icon aria-hidden="true" slot="start" name="create-outline"></ion-icon>
                  <ion-label>Bulk Update</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false" *ngIf="canAccessBulkApprovalMenu">
                <ion-item routerDirection="root" lines="none" [routerLink]="['/bulk-approval-history']" detail="false"
                  routerLinkActive="selected">
                  <ion-icon aria-hidden="true" slot="start" name="checkmark-done-outline"></ion-icon>
                  <ion-label>Bulk Approval History</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false" *ngIf="canAccessPreBulkApprovalMenu">
                <ion-item routerDirection="root" lines="none" [routerLink]="['/pre-bulk-approval-history']" detail="false"
                  routerLinkActive="selected">
                  <ion-icon aria-hidden="true" slot="start" name="reader-outline"></ion-icon>
                  <ion-label>Pre-Bulk Approval History</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>
          </ng-container>
          
          <ion-menu-toggle auto-hide="false" *ngIf="role?.is_marketing">
            <!-- Marketing Activities -->
            <ion-item routerDirection="root" lines="none" [routerLink]="['/marketing-activity-view']" detail="false"
              routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" name="business-outline" style="color: rgb(58, 161, 6);">
              </ion-icon>
              <ion-label>Marketing Activities</ion-label>
            </ion-item>

            <!-- Submenu Items -->
            <ion-list style="margin-left: 15px;">
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" lines="none" [routerLink]="['/campaign-projection']" detail="false"
                  routerLinkActive="selected">
                  <ion-icon aria-hidden="true" slot="start" name="layers-outline"
                    style="color: rgb(142, 3, 73);"></ion-icon>
                  <ion-label style="text-wrap: nowrap;">Campaign Projection</ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" lines="none" [routerLink]="['/projection-vs-actual']" detail="false"
                  routerLinkActive="selected">
                  <ion-icon aria-hidden="true" slot="start" name="bar-chart"
                    style="color: rgb(3, 133, 142);"></ion-icon>
                  <ion-label>Projection vs Actual</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>
          </ion-menu-toggle>

          <ion-menu-toggle auto-hide="false" *ngIf="role?.is_takedown_visible">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/takedown-logs']" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon name="arrow-down-circle-outline" aria-hidden="true" slot="start" style="color: red;"></ion-icon>
              <ion-label>Takedown Logs</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" *ngIf="role?.is_ddex_delivery_visible">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/ddex-delivery']" lines="none" detail="false"
              routerLinkActive="selected">
              <!-- <ion-icon aria-hidden="true" slot="start" name="trash-outline" style="color: red;"></ion-icon> -->
              <!-- <ion-icon aria-hidden="true" slot="start" name="log-out-outline" style="color:blue;"></ion-icon> -->
              <ion-icon aria-hidden="true" slot="start" name="documents-outline" style="color:blue;"></ion-icon>
              <ion-label>DDEX Delivery</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Role-wise permission change: Partner Management visibility comes from the assigned role, not user flags -->
          <!-- <ion-menu-toggle auto-hide="false" *ngIf="current_user?.is_partner_management_visible"> -->
          <ion-menu-toggle auto-hide="false" *ngIf="currentPermissions?.is_partner_management_visible">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/partner-view']" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon name="people-outline" aria-hidden="true" slot="start"
                style="color: rgb(57, 15, 207);"></ion-icon>
              <ion-label>Partner Management</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/published-track']" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="library-outline" style="color: #4b7bec;"></ion-icon>
              <ion-label>Tips Library</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" *ngIf="canAccessTipsVideoLibrary">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/tips-video-library']" detail="false"
              routerLinkActive="selected">
              <ion-icon slot="start" name="videocam-outline" style="color: #8e44ad;"></ion-icon>
              <ion-label>TIPS Video Library</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <!-- Role-wise permission change: Legal access is role-driven (`is_legal` on roles); do not merge legacy user.is_legal -->
          <!-- <ion-menu-toggle auto-hide="false" *ngIf="role?.is_legal || current_user?.is_legal"> -->
          <ion-menu-toggle auto-hide="false" *ngIf="role?.is_legal || currentPermissions?.is_legal">
            <ion-item routerDirection="root" lines="none" [routerLink]="['/legal-noc']" lines="none" detail="false"
              routerLinkActive="selected">
              <ion-icon aria-hidden="true" slot="start" name="document-text-outline"
                style="color:rgb(11, 72, 129);"></ion-icon>
              <ion-label>Legal NOC</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <!-- Admin Section (Requirement 1) -->
          <ion-menu-toggle auto-hide="false" *ngIf="currentPermissions?.is_super_admin || role?.is_super_admin">
            <ion-item-divider style="margin-top:20px; background: transparent;">
              <ion-label style="font-size: 0.8rem; opacity: 0.6;">System Admin</ion-label>
            </ion-item-divider>
            <ion-item routerDirection="root" lines="none" [routerLink]="['/admin/users']" detail="false"
              routerLinkActive="selected" class="admin-link">
              <ion-icon slot="start" name="shield-checkmark-outline" class="user-permission-icon"></ion-icon>
              <ion-label style="font-size: 15px;">Users and Permissions</ion-label>
            </ion-item>
          </ion-menu-toggle>

        </ion-list>

      </ion-content>

    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>